const themes = {
  blue: {
    primary: '#1890ff',
    secondary: '#69b1ff',
    bg: '#f5f7fa'
  },
  black: {
    primary: '#333',
    secondary: '#555',
    bg: '#eee'
  },
  white: {
    primary: '#fff',
    secondary: '#f5f5f5',
    bg: '#fff'
  }
}

export default {
  namespaced: true,
  state: {
    themeColor: localStorage.getItem('theme') || 'blue',
    themes
  },
  mutations: {
    SET_THEME(state, name) {
      state.themeColor = name
      localStorage.setItem('theme', name)
      const c = state.themes[name]
      document.documentElement.style.setProperty('--color', c.primary)
      document.documentElement.style.setProperty('--sub-color', c.secondary)
      document.body.style.background = c.bg
    }
  },
  actions: {
    set({ commit }, name) {
      commit('SET_THEME', name)
    }
  }
}